/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_TaglineInputs */

const en_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your product usable from Claude, ChatGPT and Cursor.`)
};

const ar_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجعل منتجك قابلا للاستخدام من Claude وChatGPT وCursor.`)
};

const bn_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার প্রোডাক্ট Claude, ChatGPT আর Cursor থেকে ব্যবহারযোগ্য করুন।`)
};

const de_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machen Sie Ihr Produkt nutzbar aus Claude, ChatGPT und Cursor.`)
};

const es_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga su producto utilizable desde Claude, ChatGPT y Cursor.`)
};

const fr_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendez votre produit utilisable depuis Claude, ChatGPT et Cursor.`)
};

const pt_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torne o seu produto utilizável a partir de Claude, ChatGPT e Cursor.`)
};

const zh_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让你的产品能从 Claude、ChatGPT 和 Cursor 里直接用。`)
};

const tr_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürününüzü Claude, ChatGPT ve Cursor içinden kullanılabilir yapın.`)
};

const ru_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделайте свой продукт доступным из Claude, ChatGPT и Cursor.`)
};

const pl_svc_mcp_server_development_tagline = /** @type {(inputs: Svc_Mcp_Server_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spraw, by produkt dał się używać z Claude, ChatGPT i Cursora.`)
};

/**
* | output |
* | --- |
* | "Make your product usable from Claude, ChatGPT and Cursor." |
*
* @param {Svc_Mcp_Server_Development_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_tagline = /** @type {((inputs?: Svc_Mcp_Server_Development_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_tagline(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_tagline(inputs)
	if (locale === "de") return de_svc_mcp_server_development_tagline(inputs)
	if (locale === "es") return es_svc_mcp_server_development_tagline(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_tagline(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_tagline(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_tagline(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_tagline(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_tagline(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_tagline(inputs)
	return en_svc_mcp_server_development_tagline(inputs)
});
export { svc_mcp_server_development_tagline as "svc_mcp-server-development_tagline" }